import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { RadioGroupItem } from './radio-group-item';
import { MatRadioChange } from '@angular/material/radio';
import { FormControlEx } from '../forms/form-control';

@Component({
    selector: 'app-radio-group',
    templateUrl: './radio-group.component.html',
    styleUrls: ['./radio-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RadioGroupComponent<TValue = string | boolean> {
  @Input() items: RadioGroupItem<TValue>[];
  @Input() control: AbstractControl;
  @Input() caption: string;

  @Output() readonly valueChange: EventEmitter<TValue> = new EventEmitter<TValue>();

  get fieldCaption(): string {
    return this.caption ?? (this.control as FormControlEx)?.caption;
  }

  // The radio's parent is always the owning FormGroup at runtime; cast for the
  // [formGroup] binding which requires FormGroup (parent is typed as a union).
  get parentFormGroup(): FormGroup {
    return this.control?.parent as FormGroup;
  }

  onOptionChange(event: MatRadioChange) {
    this.control.setValue(event.value);
    this.control.markAsDirty(); // (only pure user interaction affects the dirty and touched state, however we explicitly want dirty after the setValue.)
    this.valueChange.emit(event.value);
  }
}
